<script>
import { ProductionStatisticsServiceProxy, ProductionPlanTypeServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import QualityProcess from './components/QualityProcess'
import AdvanceSearch from '../compenents/AdvanceSearch'

const pssp = new ProductionStatisticsServiceProxy()
const productionPlanTypeServiceProxy = new ProductionPlanTypeServiceProxy()

export default {
  components: {
    AdvanceSearch,
    QualityProcess
  },
  data() {
    return {
      dto: {
        planCode: '',
        productCode: '',
        productName: '',
        standardModel: '',
        typeId: ''
      },
      filter: {
        current: 1,
        size: 15
      },
      data: [],
      total: 0,
      planType: [],
      loading: false,
      scrollTopY: 600,
      scrollBottomY: 600,
      advanceVisible: false,
      selectId: '',
      resizeTimer: null,
      customRow: (record) => {
        return {
          on: {
            click: (e) => {
              this.selectId = record.id
            }
          }
        }
      }
    }
  },
  computed: {
    advanceForm() {
      return [
        { name: this.$t('page_control_code'), key: 'planCode', slot: 'input' },
        { name: this.$t('page_product_code'), key: 'productCode', slot: 'input' },
        { name: this.$t('page_product_name'), key: 'productName', slot: 'input' },
        {
          name: this.$t('page_product_specification_and_model'),
          key: 'standardModel',
          slot: 'input'
        }
      ]
    },
    columns() {
      return [
        {
          title: this.$t('page_plan_production_plan_no'),
          dataIndex: 'planCode',
          key: 'planCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_product_name'),
          dataIndex: 'productName',
          key: 'productName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_product_code'),
          dataIndex: 'productCode',
          key: 'productCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_product_specification_and_model'),
          dataIndex: 'standardModel',
          key: 'standardModel',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_qc_plan_assign_num'),
          dataIndex: 'reportNum',
          key: 'reportNum',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_qc_plan_quality_num'),
          dataIndex: 'qualifyNum',
          key: 'qualifyNum',
          width: 120,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    productionPlanTypeServiceProxy.getProductionPlanTypeInfo().then((types) => {
      const value = types
      if (value && value.length) {
        this.planType = value
          .map((res) => {
            const id = res.id
            const value = {
              name: res.name,
              id: id
            }
            return value
          })
        console.log(this.planType)
        this.dto.typeId = this.planType[0].id
      }
      this.getList()
    })
    this.$nextTick(() => {
      this.getHeight()
      this.changeY()
    })
  },
  methods: {
    async getList() {
      this.loading = true
      const res = await pssp.qcPlan(this.filter.current, this.dto, this.filter.size)
      this.data = res.records
      if (res.records && res.records.length && this.selectId == '') {
        this.selectId = res.records[0].id
      }
      this.total = Number(res.total)
      this.loading = false
    },
    getHeight() {
      const topDiv = document.getElementById('quality-content')
      console.log(topDiv.clientHeight)
      this.scrollTopY = topDiv.clientHeight / 2 - 68
      this.scrollBottomY = topDiv.clientHeight / 2 - 76
    },
    changeY() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      this.resizeTimer = setTimeout(function() {
        const topDiv = document.getElementById('quality-content-top')
        console.log(topDiv.clientHeight)
        this.scrollTopY = topDiv.clientHeight - 68
        const topBody = document.querySelector('#quality-content-top .ant-table-body')
        if (topBody) {
          topBody.style.maxHeight = topDiv.clientHeight - 68 + 'px'
        }
        const bottomDiv = document.getElementById('quality-content-bottom')
        console.log(bottomDiv.clientHeight)
        this.scrollBottomY = bottomDiv.clientHeight - 68
        const bottomBody = document.querySelector('#quality-content-bottom .ant-table-body')
        if (bottomBody) {
          bottomBody.style.maxHeight = bottomDiv.clientHeight - 68 + 'px'
        }
      }, 100)
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleChange(value) {
      this.filter.current = 1
      this.dto.typeId = value
      this.getList()
    },
    handleTableChange(value) {
      this.filter.current = value
      this.getList()
    },
    onClose() {
      this.advanceVisible = false
    },
    openAdvance() {
      this.advanceVisible = !this.advanceVisible
    },
    onSearch(value) {
      Object.keys(value).forEach((key) => {
        this.dto[key] = value[key]
      })
      this.filter.current = 1
      this.getList()
      // this.advanceVisible = false
    }
  }
}
</script>

<template>
  <div class="quality-body">
    <div class="cause-quality-top">
      <!-- <a-button>导出</a-button> -->
      <div></div>
      <div>
        <a-select :value="dto.typeId" style="width: 120px" @change="handleChange">
          <template v-for="(type, index) in planType">
            <a-select-option :key="index" :value="type.id">
              {{ type.name }}
            </a-select-option>
          </template>
        </a-select>
        <a-button style="margin-left: 4px" @click="openAdvance()">{{
          $t('page_bill_settings_gaosearch')
        }}</a-button>
      </div>
    </div>
    <div class="quality-content" id="quality-content">
      <div class="quality-content-top" id="quality-content-top">
        <ml-table
          :columns="columns"
          rowKey="id"
          :loading="loading"
          :customRow="customRow"
          :selectRowKey="selectId"
          :data-source="data"
          :scroll="{ y: scrollTopY, x: 720 }"
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          :show-total="(total) => `${showTotal(total)}`"
          :current="filter.current"
          :pageSize="filter.size"
          :total="total"
          @change="handleTableChange"
        />
      </div>
      <div v-resize="{ axis: 'y', cb: this.changeY }"></div>
      <div class="quality-content-bottom" id="quality-content-bottom">
        <quality-process :planId="selectId" :scroll="scrollBottomY"></quality-process>
      </div>
    </div>
    <advance-search
      :visible="advanceVisible"
      :subTitle="`(${$t('page_qc_quality_control')})`"
      @close="onClose()"
      @search="(value) => onSearch(value)"
      :form="advanceForm"
      :value="dto"
    ></advance-search>
  </div>
</template>

<style scoped>
.cause-quality-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding-bottom: 8px;
}
.quality-body {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.quality-content {
  height: calc(100% - 41px);
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.quality-content-top {
  height: 50%;
  position: relative;
}
.quality-content-bottom {
  height: calc(50% - 8px);
  position: relative;
}
</style>
